export default __webpack_public_path__ + "static/media/9.c8983aba.png";